import React from 'react'
import { Tabs, Form,  message, Spin} from 'antd';
import Mmdl from "./mmdl" //密码登录
import Smdl from "./smdl" //扫码登录
import Yzmdl from './yzmdl' //验证码登录
import SelectGroup from './SelectGroup' //选择企业
import {API_CONFIG} from '../../api/config.js'
import api from '../../api/api.js'
import './login.less'
const { TabPane } = Tabs

class Login extends React.Component {
    state = {
        key: '1', //tab切换 1:密码或者验证码登录 2:扫码登录
        has_team:false,//tab2 是否有团队
        team:[], //企业列表
        isCode: false, //是否验证码登录
        isLogin: false, //是否登录
        isLoading: false, //页面是否处于加载
    }
    componentDidMount() {

        console.log(this.getQueryString('source'))

        // 企业微信登录
        if(this.getQueryString('source') === 'wework'){

            this.setState({
                isLoading: true
            })

            api.weworkLogin({
                wework_token: this.getQueryString('access_token') 
            }).then(res => {
                this.setState({
                    isLoading: false
                })
                if(res.code === 0){
                    document.cookie= `${API_CONFIG.company_token}=${res.content.access_token};domain=colourlife.com;;path=/;`    
                    document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                    window.location.href=`${API_CONFIG.yun_base}`
                }else{
                    message.error(res.message)    
                }
            }).catch(err => {
                message.error('企业微信登录失败')
            })       


        }else{ //账号密码、验证码、扫码登录

            let url = decodeURIComponent(this.getQueryString('redirect_url'))
            if(url && url !== 'null') {
                sessionStorage.setItem('market_url', url )
            } 
            if(this.getQueryString('companychange') === 'true'){
                sessionStorage.setItem('companychange', 'true')
                this.setState({
                    isLogin: true
                }, () => {
                    this.getTeam()
                })      
            } else {
                sessionStorage.setItem('companychange', '')
                let team = JSON.parse(sessionStorage.getItem('team'))
                if(this.getQueryString('has_team') === 'true' && team.length){
                    this.setState({
                        isLogin: true,
                    })
                }
            }
        }
        
    }
    
    getTeam () {
        const token = this.getCookie(API_CONFIG.cloud_token)
        sessionStorage.setItem('changeCompany_token',token);
        api.queryCompany({
            access_token:token 
        }).then(res => {
           if(res.content.team.length) {
                sessionStorage.setItem('team',JSON.stringify(res.content.team));
                this.setState({
                    team: res.content.team,
                })
            } 
        }).catch(err => {
            message.error('没有查询到企业')
        })
    }

    setLogintype = (value) =>{
        this.setState({
            isCode: value
        })
    }
    onSucessLogin = (isLogin,team) => {
        
        if(team.length  > 1){
            this.setState({
                team,
                isLogin,
            })
        } else {
            // 登录指定团队后台
            api.get_company_login({
                access_token: sessionStorage.getItem('access_token'),
                corp_uuid: team[0].id,
                source:sessionStorage.getItem('source')
            }).then(res=>{
                if(res.code===0) {
                    sessionStorage.setItem('company_token',res.content.access_token)
                    document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                    if(sessionStorage.getItem('market_url')){
                        let market_url = sessionStorage.getItem('market_url')
                        window.location.href=`${market_url}`
                    } else {
                        window.location.href=`${API_CONFIG.yun_base}`
                    }
                }
            })
        }
       
    }

    getCookie(name) {
        let cookieArr = document.cookie.split(';')
        for(let item of cookieArr){
            if(item.split('=')[0].trim() === name){
                let token = item.split(name)[1]
                return token.slice(1, token.length)
            }
        }
    }
        
    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r;
        if(window.location.search){
          r=window.location.search.substr(1).match(reg);
        }else{
          r=this.props.location.search.substr(1).match(reg);
        }
        if (r != null) return unescape(r[2]);
        return null;
    }
    render() {
        const { key, isCode, isLogin, team, isLoading } = this.state
        return (
        <div className='login' >
            <Spin spinning={isLoading}>
                <div className="left">
                    <div className='header'>
                        <img src={require("./../../imgs/czy_logo.svg")} alt=''/>
                    </div>
                    <div className='content'>
                    { isLogin ?  
                    <SelectGroup enterprise_list={team} /> :
                    <Tabs 
                            activeKey={key} 
                            onChange={() => {
                                this.setState({
                                    key: key === '1' ? '2' : '1'
                                })
                            }}
                        >
                            <TabPane tab={ isCode  ? '验证码登录' :'账号登录'  }  key="1" className={key === '1' ? 'select-key' : ''}>
                            { isCode ?  
                            <Yzmdl 
                                setLogintype={this.setLogintype} 
                                onSucessLogin={this.onSucessLogin}
                                history={this.props.history} 
                            /> : 
                            <Mmdl 
                                setLogintype={this.setLogintype} 
                                history={this.props.history} 
                                onSucessLogin={this.onSucessLogin}
                            />}
                            </TabPane>
                            <TabPane tab="扫码登录" key="2" className={key === '2' ? 'select-key' : ''}>
                                <Smdl 
                                    onSucessLogin={this.onSucessLogin}
                                    history={this.props.history} 
                                    tabindex={this.state.key}
                                />
                            </TabPane>
                        </Tabs>}
                    </div>
                </div>
             
                <div className='right'>
                    <div className='font'>
                            <div >  
                                <img src={require("./../../imgs/Service.png")} alt=''/>
                            </div>
                            <div className='toyourfamily'> 
                                <span className='to'>to</span> 
                                <span className='your'>your</span>  
                                <span className='family' >family </span> 
                            </div>
                            <div  className='Chinese'> 把社区服务做到家</div>
                    </div>
                </div>
                <div className='footer'　>

                    Copyright © 深圳市彩之云网络科技有限公司,All <span style={{color:'#fff'}}>Rights Reserved | 网站备案号：粤ICP备13038151号</span>
                </div>
            </Spin>
        </div>)
    }
}
export default Form.create({})(Login)


// WEBPACK FOOTER //
// ./src/pages/login/login.jsx